import React from 'react';
import { useUserData } from '@/context/UserDataContext';
import { FormSection } from '../../shared/FormSection';
import AnimatedSelectionGroup, { AnimatedSelectionOption } from '../../AnimatedSelectionGroup';
import { RADIO_BUTTON_ANIMATION_DELAY } from '@/components/animations/transitions';
import { Cigarette, Ban } from 'lucide-react';

interface SmokingVapingProps {
  error?: string;
  isLastQuestion?: boolean;
  onComplete?: (value: boolean) => void;
}

const SMOKING_OPTIONS: AnimatedSelectionOption<string>[] = [
  { value: 'true', label: 'Yes', icon: <Cigarette className="h-5 w-5" /> },
  { value: 'false', label: 'No', icon: <Ban className="h-5 w-5" /> }
];

const SmokingVaping: React.FC<SmokingVapingProps> = ({ error, isLastQuestion, onComplete }) => {
  const { userData, setUserData } = useUserData();

  const handleSmokingChange = (value: string) => {
    const booleanValue = value === 'true';
    setUserData(prev => ({ ...prev, smoking: booleanValue }));
  };

  return (
    <FormSection
      question="Do you smoke or vape?"
      helperText="Smoking or vaping can have various effects on your body, including your immune system, lung health, and overall wellbeing which can be aided by certain supplements."
      error={error}
    >
      <AnimatedSelectionGroup
        options={SMOKING_OPTIONS}
        value={userData.smoking?.toString()}
        onChange={handleSmokingChange}
        name="smoking"
        onComplete={() => {}}
        className="!grid-cols-2"
      />
    </FormSection>
  );
};

export default SmokingVaping; 